module.exports = __webpack_public_path__ + "img/corrected.a31a82fb.png";